.modal {
	min-width: 85vw;
	overflow: hidden;

	.divPreview {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;

		.previewFrame {
			margin: 0 auto;
			width: 85vw;
			height: 65vh;
			border: none;
		}
	}

	@media (max-width: 768px) {
		min-width: 100%;
		.divPreview {
			.previewFrame {
				width: 100%;
				height: auto;
			}
		}
	}
}
